var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FULFILLED_STATUS } from 'constants/app.constant';
import { PERFORMANCE_LEVEL_LABELS } from 'constants/performanceLevel.constant';
import { facadeApi, perFacadeApi } from 'helpers/api.helper';
import { getStudentUserFullName } from 'helpers/app.helper';
import { isEmpty } from 'lodash';
import { SCORE_SCALE_CONSTANT } from '../constants/had.constant';
var fetchPrograms = function (evolveUsername) {
    if (evolveUsername) {
        return perFacadeApi.get("/hesi/dwh/cohort/programs?evolveUsername=".concat(evolveUsername));
    }
    return perFacadeApi.get('/hesi/dwh/cohort/programs');
};
var fetchCohortsByProgramIds = function (programIds, evolveUsername) {
    if (programIds && programIds.length) {
        var programIdsFilter = programIds.filter(Boolean);
        if (!programIdsFilter.length) {
            return Promise.resolve({ data: [] });
        }
        if (evolveUsername) {
            return perFacadeApi.post("/hesi/dwh/cohort/cohorts?evolveUsername=".concat(evolveUsername), { data: programIds });
        }
        return perFacadeApi.post("/hesi/dwh/cohort/cohorts", { data: programIds });
    }
    return Promise.resolve({ data: [] });
};
var fetchCohortDetail = function (_a) {
    var programId = _a.programId, cohortId = _a.cohortId, evolveUsername = _a.evolveUsername;
    if (cohortId && programId) {
        if (evolveUsername) {
            return perFacadeApi.get("/hesi/cohort/cohortDetail?programId=".concat(programId, "&cohortId=").concat(cohortId, "&evolveUsername=").concat(evolveUsername));
        }
        return perFacadeApi.get("/hesi/cohort/cohortDetail?programId=".concat(programId, "&cohortId=").concat(cohortId));
    }
    return Promise.resolve({ data: {} });
};
var fetchCohortDetailDwh = function (_a) {
    var programId = _a.programId, cohortId = _a.cohortId, evolveUsername = _a.evolveUsername;
    var baseUrl = '/hesi/dwh/cohort/cohortDetail';
    var params = new URLSearchParams();
    if (cohortId && programId) {
        if (evolveUsername) {
            params.append('evolveUsername', evolveUsername);
        }
        params.append('programId', programId);
        params.append('cohortId', cohortId);
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params));
    }
    return Promise.resolve({ data: {} });
};
var fetchCohortExams = function (cohortId, threshold) {
    if (cohortId) {
        var params = new URLSearchParams({ cohortId: String(cohortId) });
        if (threshold !== undefined && threshold !== null) {
            params.append('threshold', String(threshold));
        }
        return perFacadeApi.get("/hesi/dwh/cohort/exams?".concat(params));
    }
    return Promise.resolve({ data: [] });
};
var fetchCohortExamTrendChartDataDwh = function (cohortId) {
    if (cohortId) {
        return perFacadeApi.get("/hesi/dwh/cohort/exam/trendline?cohortId=".concat(cohortId));
    }
    return Promise.resolve({ data: {} });
};
var fetchCohortExamTrendChartData = function (cohortId) {
    if (cohortId) {
        return perFacadeApi.get("/hesi/cohort/exam/trendline?cohortId=".concat(cohortId));
    }
    return Promise.resolve({ data: {} });
};
var fetchTrendLineByProgram = function (evolveUserName, programId) {
    if (evolveUserName && programId) {
        return perFacadeApi.get("/hesi/cohort/student/trendlineByProgram?evolveUserName=".concat(evolveUserName, "&programId=").concat(programId));
    }
    return Promise.resolve({ data: {} });
};
var fetchTrendLineByProgramDwh = function (evolveUserName, programId) {
    if (evolveUserName && programId) {
        return perFacadeApi.get("/hesi/dwh/cohort/student/trendlineByProgram?evolveUserName=".concat(evolveUserName, "&programId=").concat(programId));
    }
    return Promise.resolve({ data: {} });
};
var fetchCohortExamBarChartData = function (cohortId) {
    if (cohortId) {
        return facadeApi.get("/hesi/app/cohort/student/exam?cohortId=".concat(cohortId));
    }
    return Promise.resolve({ data: {} });
};
var fetchCohortStudents = function (cohortId) {
    if (cohortId) {
        return perFacadeApi.get("/hesi/dwh/cohort/students?cohortId=".concat(cohortId));
    }
    return Promise.resolve({ data: [] });
};
var fetchExamStudents = function (cohortId, examId) {
    if (cohortId && examId) {
        return perFacadeApi.get("/hesi/dwh/cohort/examDetail?cohortId=".concat(cohortId, "&examId=").concat(examId));
    }
    return Promise.resolve({ data: [] });
};
var fetchStudentDetail = function (cohortId, evolveUserName) {
    if (cohortId && evolveUserName) {
        return perFacadeApi.get("/hesi/dwh/cohort/studentDetail?cohortId=".concat(cohortId, "&evolveUserName=").concat(evolveUserName));
    }
    return Promise.resolve({ data: {} });
};
var fetchStudentDetailV2 = function (cohortId, evolveUserName) {
    if (cohortId && evolveUserName) {
        return perFacadeApi.get("/hesi/dwh/cohort/v2/studentDetail?cohortId=".concat(cohortId, "&evolveUserName=").concat(evolveUserName));
    }
    return Promise.resolve({ data: {} });
};
var fetchStudentDetailByProgram = function (evolveUserName, programId) {
    if (evolveUserName && programId) {
        return perFacadeApi.get("/hesi/dwh/cohort/studentDetailByProgram?evolveUserName=".concat(evolveUserName, "&programId=").concat(programId));
    }
    return Promise.resolve({ data: {} });
};
var fetchStudentDetailByProgramV2 = function (evolveUserName, programId) {
    if (evolveUserName && programId) {
        return perFacadeApi.get("/hesi/dwh/cohort/v2/studentDetailByProgram?evolveUserName=".concat(evolveUserName, "&programId=").concat(programId));
    }
    return Promise.resolve({ data: {} });
};
var fetchLegacyStudentDetailByProgram = function (evolveUserName, programId) {
    if (evolveUserName && programId) {
        return perFacadeApi.get("/hesi/cohort/studentDetailByProgram?evolveUserName=".concat(evolveUserName, "&programId=").concat(programId));
    }
    return Promise.resolve({ data: {} });
};
var fetchDemoStudentDetailByProgram = function (evolveUserName, programId) {
    if (evolveUserName && programId) {
        return perFacadeApi.get("/hesi/dwh/cohort/demoStudentDetailByProgram?evolveUserName=".concat(evolveUserName, "&programId=").concat(programId));
    }
    return Promise.resolve({ data: {} });
};
var fetchDemoStudentDetailByProgramV2 = function (evolveUserName, programId) {
    if (evolveUserName && programId) {
        return perFacadeApi.get("/hesi/dwh/cohort/v2/demoStudentDetailByProgram?evolveUserName=".concat(evolveUserName, "&programId=").concat(programId));
    }
    return Promise.resolve({ data: {} });
};
var fetchStudentExamCategory = function (cohortId, evolveUserName, categoryGroupId) {
    if (cohortId && evolveUserName && categoryGroupId) {
        return perFacadeApi.get("/hesi/dwh/cohort/studentExamCategory?cohortId=".concat(cohortId, "&evolveUserName=").concat(evolveUserName, "&categoryGroupId=").concat(categoryGroupId));
    }
    return Promise.resolve({ data: [] });
};
var fetchLegacyStudentExamCategory = function (cohortId, evolveUserName, categoryGroupId) {
    if (cohortId && evolveUserName && categoryGroupId) {
        return perFacadeApi.get("/hesi/cohort/studentExamCategory?cohortId=".concat(cohortId, "&evolveUserName=").concat(evolveUserName, "&categoryGroupId=").concat(categoryGroupId));
    }
    return Promise.resolve({ data: [] });
};
var fetchStudentTrendChartData = function (cohortId, evolveUserName) {
    if (cohortId && evolveUserName) {
        return perFacadeApi.get("/hesi/cohort/student/trendline?cohortId=".concat(cohortId, "&evolveUserName=").concat(evolveUserName));
    }
    return Promise.resolve({ data: {} });
};
var fetchStudentTrendChartDataDwh = function (cohortId, evolveUserName) {
    if (cohortId && evolveUserName) {
        return perFacadeApi.get("/hesi/dwh/cohort/student/trendline?cohortId=".concat(cohortId, "&evolveUserName=").concat(evolveUserName));
    }
    return Promise.resolve({ data: {} });
};
var fetchCategorySummary = function (cohortId, examTypeName, categoryGroupId, threshold) {
    if (cohortId && examTypeName && categoryGroupId) {
        var params = new URLSearchParams({ cohortId: String(cohortId), examTypeName: examTypeName, categoryGroupId: String(categoryGroupId) });
        if (threshold !== undefined && threshold !== null) {
            params.append('threshold', String(threshold));
        }
        return perFacadeApi.get("/hesi/cohort/categorySummary?".concat(params));
    }
    return Promise.resolve({ data: [] });
};
var fetchCategorySummaryDwh = function (cohortId, examTypeName, categoryGroupId, threshold) {
    if (cohortId && examTypeName && categoryGroupId) {
        var params = new URLSearchParams({ cohortId: String(cohortId), examTypeName: examTypeName, categoryGroupId: String(categoryGroupId) });
        if (threshold !== undefined && threshold !== null) {
            params.append('threshold', String(threshold));
        }
        return perFacadeApi.get("/hesi/dwh/cohort/categorySummary?".concat(params));
    }
    return Promise.resolve({ data: [] });
};
var fetchExamCategoryPerformance = function (examId, cohortId, categoryGroupId) {
    if (examId && cohortId && categoryGroupId) {
        return perFacadeApi.get("/hesi/exam/categoryPerformance?examId=".concat(examId, "&cohortId=").concat(cohortId, "&categoryGroupId=").concat(categoryGroupId));
    }
    return Promise.resolve({ data: {} });
};
var fetchExamCategoryPerformanceDwh = function (examId, cohortId, categoryGroupId) {
    if (examId && cohortId && categoryGroupId) {
        return perFacadeApi.get("/hesi/dwh/exam/categoryPerformance?examId=".concat(examId, "&cohortId=").concat(cohortId, "&categoryGroupId=").concat(categoryGroupId));
    }
    return Promise.resolve({ data: {} });
};
var fetchCategoryGroupList = function (cohortId) {
    if (cohortId) {
        return perFacadeApi.get("/hesi/cohort/categoryGroupList?cohortId=".concat(cohortId));
    }
    return Promise.resolve({ data: [] });
};
var fetchCategoryGroupListDwh = function (cohortId) {
    if (cohortId) {
        return perFacadeApi.get("/hesi/dwh/cohort/categoryGroupList?cohortId=".concat(cohortId));
    }
    return Promise.resolve({ data: [] });
};
var fetchStudentExamCategoryByProgram = function (evolveUserName, programId, categoryGroupId) {
    if (evolveUserName && programId && categoryGroupId) {
        return perFacadeApi.get("/hesi/cohort/studentExamCategoryByProgram?evolveUserName=".concat(evolveUserName, "&programId=").concat(programId, "&categoryGroupId=").concat(categoryGroupId));
    }
    return Promise.resolve({ data: [] });
};
var fetchStudentExamCategoryByProgramDwh = function (evolveUserName, programId, categoryGroupId) {
    if (evolveUserName && programId && categoryGroupId) {
        return perFacadeApi.get("/hesi/dwh/cohort/studentExamCategoryByProgram?evolveUserName=".concat(evolveUserName, "&programId=").concat(programId, "&categoryGroupId=").concat(categoryGroupId));
    }
    return Promise.resolve({ data: [] });
};
var fetchCategoryExamData = function (cohortId, categoryGroupId) {
    if (cohortId && categoryGroupId) {
        return perFacadeApi.get("/hesi/dwh/cohort/categoryExamData?cohortId=".concat(cohortId, "&categoryGroupId=").concat(categoryGroupId));
    }
    return Promise.resolve({ data: [] });
};
var fetchExamAuthessKeys = function () {
    return perFacadeApi.get('/ngn/examAuthessKeys');
};
var fetchNGNCourse = function (cohortId) {
    if (!cohortId) {
        return Promise.resolve({ data: [] });
    }
    return facadeApi.get("/hesi/app/nclex/cohort/".concat(cohortId, "/courseSections"));
};
var fetchNGNItem = function (_a) {
    var cohortId = _a.cohortId, examId = _a.examId, isStudentLevel = _a.isStudentLevel, studentEvolveUsername = _a.studentEvolveUsername;
    if (!cohortId && !examId) {
        return Promise.resolve({ data: [] });
    }
    if (isStudentLevel) {
        return perFacadeApi.get("/hesi/dwh/ngn/student/item?cohortId=".concat(cohortId, "&evolveUserName=").concat(studentEvolveUsername));
    }
    if (examId) {
        return perFacadeApi.get("/hesi/dwh/ngn/item?cohortId=".concat(cohortId, "&examId=").concat(examId));
    }
    return perFacadeApi.get("/hesi/dwh/ngn/item?cohortId=".concat(cohortId));
};
var fetchAssessmentCompletion = function (assessmentKey, courseSectionIds, examGroupIds, jwt) {
    if (!assessmentKey || !courseSectionIds) {
        return Promise.resolve({ data: [] });
    }
    return perFacadeApi.get("/ngn/assessment/completions?assessmentKey=".concat(assessmentKey, "&courseSectionIds=").concat(courseSectionIds, "&examGroupIds=").concat(examGroupIds, "&jwt=").concat(jwt));
};
var fetchRelatedUserInfo = function (eolsUserId) {
    if (!eolsUserId) {
        return Promise.resolve({ data: [] });
    }
    return facadeApi.get("/hesi/app/user/".concat(eolsUserId, "/related"));
};
var fetchCourseLinkCWAndEHR = function (courses) { return __awaiter(void 0, void 0, Promise, function () {
    var results, promises, responses;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                results = [];
                promises = courses.map(function (course) { return facadeApi.get("/sherpath/courseSections/".concat(course.id, "/evolve/product/v2")); });
                return [4 /*yield*/, Promise.allSettled(promises)];
            case 1:
                responses = _a.sent();
                responses.forEach(function (res, index) {
                    var _a;
                    if (res.status === FULFILLED_STATUS && !isEmpty((_a = res === null || res === void 0 ? void 0 : res.value) === null || _a === void 0 ? void 0 : _a.data)) {
                        results.push(courses[index]);
                    }
                });
                return [2 /*return*/, results];
        }
    });
}); };
var fetchStudentDetailByEvolveUsername = function (evolveUsername) {
    if (evolveUsername) {
        return perFacadeApi.get("/hesi/dwh/cohort/studentDetailByEvolveUsername?evolveUserName=".concat(evolveUsername));
    }
    return Promise.resolve({ data: {} });
};
var fetchStudentDetailByEvolveUsernameV2 = function (evolveUsername) {
    if (evolveUsername) {
        return perFacadeApi.get("/hesi/dwh/cohort/v2/studentDetailByEvolveUsername?evolveUserName=".concat(evolveUsername));
    }
    return Promise.resolve({ data: {} });
};
var fetchStudentExamCategoryByEvolveUsername = function (evolveUsername, categoryGroupId) {
    if (evolveUsername && categoryGroupId) {
        return perFacadeApi.get("/hesi/dwh/cohort/studentExamCategoryByEvolveUsername?evolveUserName=".concat(evolveUsername, "&categoryGroupId=").concat(categoryGroupId));
    }
    return Promise.resolve({ data: [] });
};
var fetchStudentTrendLineByEvolveUsername = function (evolveUsername) {
    if (evolveUsername) {
        return perFacadeApi.get("/hesi/dwh/cohort/student/trendlineByEvolveUsername?evolveUserName=".concat(evolveUsername));
    }
    return Promise.resolve({ data: {} });
};
var findMax = function (arr, fields) {
    return Math.max.apply(Math, arr.map(function (item) { return Math.max.apply(Math, fields.map(function (field) { return item[field] || 0; })); }));
};
var isActualData = function (actualScore) {
    return typeof actualScore === 'number' && actualScore > 0;
};
var shouldRenderCohortRelatedPage = function (storedSelectedCohort, cohortIdExtractedFromURL) {
    // Due to the current authentication approach, a user can use their token to get data of cohorts which they do not manage
    // To prevent this issue, we add a guard condition to render this page only when the cohortID matches the selectedCohortID,
    // which is set when a user click to a cohort on the HAD Dashboard home page
    return storedSelectedCohort.cohortId === cohortIdExtractedFromURL;
};
var convertScoreToPerformanceLevel = function (score) {
    var roundedScore = Math.round(score) || 0;
    if (roundedScore < SCORE_SCALE_CONSTANT.MAX_AT_RISK) {
        return PERFORMANCE_LEVEL_LABELS.atRisk;
    }
    if (roundedScore < SCORE_SCALE_CONSTANT.MAX_BELOW_ACCEPTABLE) {
        return PERFORMANCE_LEVEL_LABELS.belowAcceptable;
    }
    if (roundedScore < SCORE_SCALE_CONSTANT.MAX_ACCEPTABLE) {
        return PERFORMANCE_LEVEL_LABELS.acceptable;
    }
    return PERFORMANCE_LEVEL_LABELS.recommended;
};
var getStudentFullName = function (student) { return (student ? getStudentUserFullName(student) : ''); };
var fetchStudentSummary = function (cohortId, evolveUserName) {
    if (cohortId && evolveUserName) {
        return perFacadeApi.get("/hesi/dwh/cohort/studentSummary?evolveUserName=".concat(evolveUserName, "&cohortId=").concat(cohortId));
    }
    return Promise.resolve({ data: {} });
};
var fetchStudentSummaryV2 = function (cohortId, evolveUserName) {
    if (cohortId && evolveUserName) {
        return perFacadeApi.get("/hesi/dwh/cohort/v2/studentSummary?evolveUserName=".concat(evolveUserName, "&cohortId=").concat(cohortId));
    }
    return Promise.resolve({ data: {} });
};
var fetchStudentExams = function (cohortId, evolveUserName) {
    if (cohortId && evolveUserName) {
        return perFacadeApi.get("/hesi/dwh/cohort/studentExams?evolveUserName=".concat(evolveUserName, "&cohortId=").concat(cohortId));
    }
    return Promise.resolve({ data: [] });
};
var fetchStudentExamsV2 = function (cohortId, evolveUserName) {
    if (cohortId && evolveUserName) {
        return perFacadeApi.get("/hesi/dwh/cohort/v2/studentExams?evolveUserName=".concat(evolveUserName, "&cohortId=").concat(cohortId));
    }
    return Promise.resolve({ data: [] });
};
export { convertScoreToPerformanceLevel, fetchAssessmentCompletion, fetchCategoryExamData, fetchCategoryGroupList, fetchCategoryGroupListDwh, fetchCategorySummary, fetchCategorySummaryDwh, fetchCohortDetail, fetchCohortDetailDwh, fetchCohortExamBarChartData, fetchCohortExams, fetchCohortExamTrendChartData, fetchCohortExamTrendChartDataDwh, fetchCohortsByProgramIds, fetchCohortStudents, fetchCourseLinkCWAndEHR, fetchDemoStudentDetailByProgram, fetchDemoStudentDetailByProgramV2, fetchExamAuthessKeys, fetchExamCategoryPerformance, fetchExamCategoryPerformanceDwh, fetchExamStudents, fetchLegacyStudentDetailByProgram, fetchLegacyStudentExamCategory, fetchNGNCourse, fetchNGNItem, fetchPrograms, fetchRelatedUserInfo, fetchStudentDetail, fetchStudentDetailByEvolveUsername, fetchStudentDetailByEvolveUsernameV2, fetchStudentDetailByProgram, fetchStudentDetailByProgramV2, fetchStudentDetailV2, fetchStudentExamCategory, fetchStudentExamCategoryByEvolveUsername, fetchStudentExamCategoryByProgram, fetchStudentExamCategoryByProgramDwh, fetchStudentExams, fetchStudentExamsV2, fetchStudentSummary, fetchStudentSummaryV2, fetchStudentTrendChartData, fetchStudentTrendChartDataDwh, fetchStudentTrendLineByEvolveUsername, fetchTrendLineByProgram, fetchTrendLineByProgramDwh, findMax, getStudentFullName, isActualData, shouldRenderCohortRelatedPage };
